import NetworkService from "./NetworkService";
import ILedgerTransactionOptions from "@/Interfaces/Ledgering/ILedgerTransactionOptions";
import ILedgerTransactions from "@/Interfaces/Ledgering/ILedgerTransactions";
import ILedgerTransaciosParams from "@/Interfaces/Ledgering/ILedgerTransactionsParams";
import ILedgerTransactionsQuery from "@/Interfaces/Ledgering/ILedgerTransactionsQuery";
import ILedgerTransactionPostResponse from "@/Interfaces/Ledgering/ILedgerTransactionPostResponse";
import ILedgerTransactionRequest from "@/Interfaces/Ledgering/ILedgerTransactionRequest";
import IContractResponse from "@/Interfaces/Contract/IContractResponse";
import IContractPostRequest from "@/Interfaces/Contract/IContractPostRequest";
import IContractValidationResponse from '@/Interfaces/Contract/IContractValidationResponse';
import IContractValidateRequest from "@/Interfaces/Contract/IContractValidateRequest";
import IContractValidateParams from "@/Interfaces/Contract/IContractValidateParams";
import IContractValidationOverrideRequest from "@/Interfaces/Contract/IContractValidationOverrideRequest";
import IContractApproveRequest from "@/Interfaces/Contract/IContractApproveRequest";
import IContractApproval from "@/Interfaces/Contract/IContractApproval";
import IContractQuery from "@/Interfaces/Contract/IContractQuery";
import IRechargeInvoicePaymentItems from "@/Interfaces/Payments/IRechargeInvoicePaymentsItem";
import IConfirmRechargeInvoicePaymentRequest from "@/Interfaces/Payments/IConfirmRechargeInvoicePaymentRequest";
import IServiceFees from "@/Interfaces/FeesConfiguration/IServiceFees";
import IMarketQuery from "@/Interfaces/IMarketQuery";
import IFinancingFees from "@/Interfaces/FeesConfiguration/IFinancingFees";
import IChurnPaymentItem from "@/Interfaces/Payments/IChurnPaymentItemRaw";
import IConfirmChurnPaymentRequest from "@/Interfaces/Payments/IConfirmChurnPaymentReq";
import FCNetworkService from "./ForceCamelCaseNetworkService";
import IConfirmServiceInvoicePaymentRequest from "@/Interfaces/Payments/IConfirmServiceInvoicePaymentRequest";
import IServiceInvoicePaymentItem from "@/Interfaces/Payments/IServiceInvoicePaymentItemRaw";
import ICustomerViewParams from "@/Interfaces/ICustomerViewParams";
import ICustomerTable from '@/Interfaces/CustomersAndContracts/ICustomerTable'
import IInsuranceForm from "@/Interfaces/InsuranceClaims/IInsuranceClaimsForm";
import IInsuranceClaimsGetQuery from "@/Interfaces/InsuranceClaims/IInsuranceClaimsGetQuery"
import FileNetworkService from "./FileNetworkService";
import PostFileNetworkService from "./PostFileNetworkService";
import DatePeriod from "@/types/DatePeriod";
import { IMantisIssues } from "@/Interfaces/AlertsAndWarnings/IMantisIssues";
import { MarketSelection } from "../helpers/Helper";
import { NetworkSvcType } from "./BaseNetworkService";
import IContractData from "@/Interfaces/ContractApproval/IContractData";
import IForecast from "@/models/Portfolio/IForecast";
import { IEstimatedPortfolio, IEstimatedPortfolioV1 } from "@/models/Portfolio/IEstimatedPortfolio";
import { IEstForecastQueryV1, IForecastQueryV1 } from "@/Interfaces/Portfolio/IForecastQuery";
import { IForecastDetailsV1 } from "@/models/Portfolio/IForecastDetails";
import IForecastConfig from "@/models/Portfolio/IForecastConfig";
import IInterestPayment from "@/Interfaces/Ledgering/IInterestPayment";
import IInterestPaymentRequest from "@/Interfaces/Ledgering/IInterestPaymentRequest";
import IBankTransferPayments from "@/Interfaces/Ledgering/IBankTransferPayments";
import IBankTransferApproveOrConfirm from "@/Interfaces/Ledgering/IBankTransferApproveOrConfirm";
import { IEoPVerifications } from "@/Interfaces/EoPVerifications/IEoPVerifications";
import IEoPCreateNewReport from "@/Interfaces/EoPVerifications/IEoPCreateNewReport";
import EoPVerificationReportOperation from "@/Interfaces/EoPVerifications/EoPVerificationReportOperation";
import IEoPVerificationRequestParams from "@/Interfaces/EoPVerifications/IEoPVerificationRequestParams";
import IFileDownloadList from "@/Interfaces/FileDownloadQueue/IFileDownloadList";
import IFinalSettlementPaymentItem from "@/Interfaces/Payments/IFinalSettlementPaymentItem";
import IConfirmFinalSettlementPaymentRequest from "@/Interfaces/Payments/IConfirmFinalSettlementPaymentRequest";
import IManualJournalingEnums from "@/Interfaces/Journaling/ManualJournal/IManualJournalingEnums";
import IManualJournalBody from "@/Interfaces/Journaling/ManualJournal/IManualJournalBody";
import { ContractOwner } from "@/models/CarPurchases/ContractOwner";
import { IVcfsTrialBalance } from "@/Interfaces/VcfsTrialBalance/IVcfsTrialBalance";
import { IVcfsTrialBalanceConstituentItem } from "@/Interfaces/VcfsTrialBalance/IVcfsTrialBalanceConstituentItem";
import { IVcfsPaymentItem } from "@/Interfaces/Payments/IVcfsPaymentItem";
import { IVcfsPaymentRequest } from "@/Interfaces/Payments/IVcfsPaymentRequest";
import { VcfsTrialBalanceStatementCategories } from "@/models/enums/VcfsTrialBalanceStatementCategories";


//# -------------------------------------------------------- #

//#                        Network Services                  #

//# -------------------------------------------------------- #

export const ledgerTransactionOptions = new NetworkService<ILedgerTransactionOptions>
(
  process.env.VUE_APP_API_LEDGER_TRANSACTIONS_OPTIONS
);

export const ledgerTransactions = new NetworkService<
  ILedgerTransactions,
  ILedgerTransaciosParams,
  ILedgerTransactionsQuery,
  ILedgerTransactionRequest,
  ILedgerTransactionPostResponse
>(
  process.env.VUE_APP_API_LEDGER_TRANSACTIONS
);

export const contractHireAgreements = new NetworkService<
  IContractResponse,
  IContractPostRequest
>(
  process.env.VUE_APP_CONTRACT_HIRE_AGREEMENT_URL_PARAMS
);

export const contractValidations = new NetworkService<
  IContractValidationResponse,
  IContractPostRequest
>(
  process.env.VUE_APP_CONTRACT_VALIDATIONS_URL_PARAMS
);

export const contractApprovalValidate = new NetworkService<
  null,
  IContractValidateParams,
  IContractValidateRequest
>(
  process.env.VUE_APP_CONTRACT_APPROVAL_VALIDATE_URI
);

export const contractApprovalValidationOverride = new NetworkService<
  null,
  IContractValidateParams,
  IContractValidationOverrideRequest
>(
  process.env.VUE_APP_CONTRACT_APPROVAL_OVERRIDE_URI
);

export const contractApproval = new NetworkService<
  IContractApproval[],
  undefined,
  IContractQuery,
  IContractApproveRequest,
  string[]
>(
  process.env.VUE_APP_CONTRACT_APPROVAL_URI
);

export const serviceFees = new NetworkService<
  IServiceFees[],
  undefined,
  IMarketQuery,
  IServiceFees
>(
  process.env.VUE_APP_SERVICE_FEES_URL_PARAMS
);

export const financingFees = new NetworkService<
  IFinancingFees[],
  undefined,
  IMarketQuery,
  IFinancingFees
>(
  process.env.VUE_APP_FINANCING_FEES_URL_PARAMS
);

export const interestPayments = new NetworkService<
  IInterestPayment[],
  undefined,
  IMarketQuery,
  IInterestPayment
>(
  process.env.VUE_APP_INTEREST_PAYMENTS_URL_PARAMS
);

export const manualCreditScore = new NetworkService<null,{
  username: string;
  manualCreditScore: number;
  contractID: string;
}>(
  process.env.VUE_APP_MANUAL_CREDIT_SCORE_URI
);

export const rechargeInvoicePayments = new NetworkService<IRechargeInvoicePaymentItems[]>(
  process.env.VUE_APP_UNPAID_RECHARGE_INVOICES_URL_PARAMS
);
export const confirmRechargeInvoicePayment = new NetworkService<null, IConfirmRechargeInvoicePaymentRequest >(
  process.env.VUE_APP_CONFIRM_RECHARGE_INVOICE_PAYMENTS_URL_PARAMS
);

export const contractApprovalExport = new NetworkService<
IContractData[],
{
  owner: string;
  rvPeriod: string;
  contractIDs: string[];
}>(
  process.env.VUE_APP_GET_CONTRACT_APPROVAL_EXPORT_URL_PARAMS
);

export const customerView = new NetworkService<
  ICustomerTable|"",
  ICustomerViewParams
>(
  process.env.VUE_APP_CUSTOMER_VIEW_URI
);

export const confirmChurnPayment = new NetworkService<null,IConfirmChurnPaymentRequest>(
  process.env.VUE_APP_CONFIRM_CHURN_PAYMENTS_URL_PARAMS
);

export const confirmInterestPayment = new NetworkService<null, IInterestPaymentRequest>(
  process.env.VUE_APP_CONFIRM_INTEREST_PAYMENT_URL_NO_PARAMS
);

export const confirmServiceInvoicePayment = new NetworkService<null, IConfirmServiceInvoicePaymentRequest>(
  process.env.VUE_APP_CONFIRM_SERVICE_INVOICE_PAYMENTS_URL_PARAMS
);

export const confirmFinalSettlementPayment = new NetworkService<null, IConfirmFinalSettlementPaymentRequest>(
  process.env.VUE_APP_CONFIRM_FINAL_SETTLEMENT_PAYMENT_URL_PARAMS
);

export const mantisIssues = new NetworkService<IMantisIssues>(
  process.env.VUE_APP_ALERTS_AND_WARNINGS_TICKETS_URL_PARAMS, NetworkSvcType.TICKET
);

export const ticketingSystem = new NetworkService<"", {
  exportAlertsAndWarnings: boolean;
  userName: string;
  market: keyof typeof MarketSelection
}>(
  process.env.VUE_APP_ALERTS_AND_WARNINGS_URL_PARAMS, NetworkSvcType.TICKET
);

export const getBankTransferPayments = new NetworkService<
IBankTransferPayments[], 
{
  market: string,
  status: string
}>(
  process.env.VUE_APP_GET_BANK_TRANSFER_PAYMENTS_URL_PARAMS
);

export const approveBankTransferPayment = new NetworkService<
null, 
IBankTransferApproveOrConfirm>(
  process.env.VUE_APP_APPROVAL_BANK_TRANSFER_PAYMENT_URL_PARAMS
);

export const confirmBankTransferPayment = new NetworkService<
null, 
IBankTransferApproveOrConfirm>(
  process.env.VUE_APP_CONFIRMATION_BANK_TRANSFER_PAYMENTS_URL_PARAMS
);

export const insuranceClaims = new NetworkService<
  IInsuranceForm[],
  null, 
  IInsuranceClaimsGetQuery,
  IInsuranceForm, 
  IInsuranceForm
>(
  process.env.VUE_APP_INSURANCE_URL_PARAMS
);

export const manualJournalingEnums = new NetworkService<
  IManualJournalingEnums
>(
  process.env.VUE_APP_MANUAL_JOURNALING_OPTIONS_URL_PARAMS
);

export const manualJournal = new NetworkService<
  null, 
  IManualJournalBody
>(
  process.env.VUE_APP_MANUAL_JOURNALING_URL_PARAMS
);

export const eoPVerificationHeader = new NetworkService<
IEoPVerifications, 
{
  market: string, 
  period: DatePeriod
}>(
  process.env.VUE_APP_EOP_VERIFICATION_HEADER_URL_PARAMS
);

export const eoPCreateNewReport = new NetworkService<
null, 
IEoPCreateNewReport
>(
  process.env.VUE_APP_EOP_VERIFICATION_NEW_REPORT_URL_PARAMS
);

export const eoPVerificationReport = new NetworkService<
EoPVerificationReportOperation[],
IEoPVerificationRequestParams
>(
  process.env.VUE_APP_EOP_VERIFICATION_OPERATION_URL_PARAMS
);

//# -------------------------------------------------------- #

//#                  File Network Services                   #

//# -------------------------------------------------------- #

export const euSecuritisationReport = new FileNetworkService<{
  type: string;
  period: DatePeriod;
},{
  ownerID: string;
}>(
  process.env.VUE_APP_GET_SECURITISATION_REPORT_URL_PARAMS
);

//# -------------------------------------------------------- #

//#             Post File Network Services                   #

//# -------------------------------------------------------- #

export const contractHireAgreementPDF = new PostFileNetworkService<{invoiceIds: string[]}>(
  process.env.VUE_APP_CONTRACT_HIRE_AGREEMENT_DOWNLOAD_URL_PARAMS
);

//# -------------------------------------------------------- #

//#             Post File Network Services                   #

//# -------------------------------------------------------- #

export const churnPayments = new FCNetworkService<IChurnPaymentItem[]|''>(
  process.env.VUE_APP_UNPAID_CHURN_PAYMENTS_URL_PARAMS
);

export const serviceInvoicePayments = new FCNetworkService<IServiceInvoicePaymentItem[]>(
  process.env.VUE_APP_UNPAID_SERVICE_INVOICES_URL_PARAMS
);

export const finalSettlementPayments = new FCNetworkService<IFinalSettlementPaymentItem[],IMarketQuery>(
  process.env.VUE_APP_FINAL_SETTLEMENT_PAYMENTS_URL_PARAMS
);

export const curPortfolioForecasts = new FCNetworkService<IForecast[], IForecastQueryV1>(
  process.env.VUE_APP_CURRENT_PORTFOLIO_FORECASTS_URI
);

export const curPortfolioForecast = new FCNetworkService<{ forecastResults: IForecastDetailsV1[] },{ id: number }>(
  process.env.VUE_APP_CURRENT_PORTFOLIO_FORECAST_DETAILS_URI
);

export const portfolioTemplate = new FCNetworkService<IEstimatedPortfolioV1, IMarketQuery, IEstForecastQueryV1>(
  process.env.VUE_APP_ESTIMATED_PORTFOLIO_TEMPLATE_URI
)

export const estimateForecast = new FCNetworkService<{ forecastResults: IForecastDetailsV1[] }, IEstimatedPortfolio>(
  process.env.VUE_APP_ESTIMATED_PORTFOLIO_FORECAST_URI
);

export const forecastConfigs = new FCNetworkService<IForecastConfig[]>(
  process.env.VUE_APP_FORECAST_CONFIGS_URI
)
export const downloadManager = new NetworkService<IFileDownloadList[],{fileId?: number;}, {userName?: string; requestData?: Object; type?: string; }>(
  process.env.VUE_APP_DOWNLOADS_MANAGER_URL_PARAMS ?? 'download-queue/{fileId}'
);
export const streamDownloadFile = new FileNetworkService<
{
  fileId: string
}>(
  process.env.VUE_APP_DOWNLOADS_MANAGER_URL_PARAMS ?? 'download-queue/{fileId}'
);
export const contractOwners = new NetworkService<
ContractOwner[]
>(
  process.env.VUE_APP_CONTRACT_OWNERS_URL_PARAMS ?? 'contract-owners'
);
export const vcfsPeriodConsituentItemsTrialBalance = new NetworkService<
  IVcfsTrialBalanceConstituentItem[],
  {
    account: string
  },
  {
    period: string,
  }
>(
  process.env.VUE_APP_VCFS_TRIAL_BALANCE_ITEMS_URL_PARAMS ?? 'vcfs-trial-balance/{account}'
);
export const vcfsTrialBalance = new NetworkService<
  IVcfsTrialBalance[],
  null, 
  {
    period: string
    upToPeriod?: boolean
    statementCategory?: keyof typeof VcfsTrialBalanceStatementCategories
  }
>(
  process.env.VUE_APP_VCFS_TRIAL_BALANCE_URL_PARAMS ?? 'vcfs-trial-balance'
);
export const vcfsTrialBalanceJournalReferenceItems = new NetworkService<
  Object[],
  {
    account: string, 
    journalReference: string
  }, 
  {
    period: string
  }
>(
  process.env.VUE_APP_VCFS_TRIAL_BALANCE_JOURNAL_REFERENCE_ITEMS_URL_PARAMS ?? 'vcfs-trial-balance/{account}/{journalReference}'
);
export const vcfsPaymentsService = new NetworkService<
  IVcfsPaymentItem[],
  { paymentReference: string },
  IVcfsPaymentRequest
>(
  process.env.VUE_APP_VCFS_PAYMENTS_URL_PARAMS ?? 'vcfs-payments/{paymentReference}'
);
export const vcfsConsolidation = new NetworkService<
  null,
  { period: string }
>(
  process.env.VUE_APP_VCFS_CONSOLIDATE_JOUNRAL_URL_PARAMS ?? 'vcfs-consolidate-journals'
);